export default "__VITE_ASSET__53f970a2__"